import { EnvironmentModel, ProjectName } from "./environment-model.interface";

export const environment: EnvironmentModel = {
  production: false,
  apiUrl: 'https://testapi.xtwin.app',
  url: 'https://testadmin.xtwin.app',
  crossTestProdSiblingUrl: 'https://admin.xtwin.app',
  name: ProjectName.xtwin,
  heliosUrl: 'https://heliostest.xtwin.app/'
};